import { render, staticRenderFns } from "./plan-simple-button.vue?vue&type=template&id=ddb6bae8"
import script from "./plan-simple-button.vue?vue&type=script&lang=js"
export * from "./plan-simple-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports